import React, { FC } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { ReduxState } from 'app/redux/types';

import { selectBets } from '../../selectors/entries';
import { selectOneClickBetActive } from '../../selectors/preferences';
import OneClickBetToggle from '../Toggle/OneClickBet';
import Settings from './components/Settings';
import StakeTypeSelect from './components/StakeTypeSelect';
import TrashCan from './components/TrashCan';

import styles from './Preferences.module.scss';

// ---

type StoreProps = {
  oneClickBetActive: boolean;
  entriesSize: number;
};

const Preferences: FC<StoreProps> = ({ oneClickBetActive, entriesSize }) => {
  const _className = classNames(styles.preferences, {
    [styles.oneClickActive]: oneClickBetActive,
  });

  return (
    <div className={_className}
         data-test="preferences-container">
      {entriesSize > 0 ? (
        <>
          <TrashCan />
          <StakeTypeSelect />
        </>
      ) : (
        <OneClickBetToggle />
      )}

      <Settings />
    </div>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  oneClickBetActive: selectOneClickBetActive(state),
  entriesSize: selectBets(state).size,
});

export default connect(mapStateToProps)(Preferences);
